import { z } from '@repo/schema'
import {
  GetCreditSafeCompanyAddressSchema,
  GetCreditSafeCompanySchema,
} from '@repo/schema/credit-safe'
import { getCreditSafeVatParams } from '@repo/sdk/helpers'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

const CreditSafeCompaniesSchema = z.object({
  companies: GetCreditSafeCompanySchema.extend({
    address: GetCreditSafeCompanyAddressSchema,
  }).array(),
})

export const createCreditSafeRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    // GET /credit-safe/companies: the companies Creditsafe holds for a VAT number. `country` is
    // used when the VAT number has no country prefix.
    companies: p
      .path('credit-safe', 'companies')
      .input(z.object({ country: z.string().optional(), vat: z.string() }))
      .query(({ input, path, upFetch }) =>
        upFetch(path, {
          params: getCreditSafeVatParams(input.vat, input.country),
          schema: CreditSafeCompaniesSchema,
        }),
      ),
  }
}
